import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import {
  Transaction_Book,
  Transaction_Payment,
  Transaction_Card,
  Transaction_Action,
} from "../../Connections/Transaction";

import Page from "../Page/Page";
import Box from "../../Components/Common/Box";
import Button from "../../Components/Common/Button";
import BoxPlural from "../../Components/Common/BoxPlural";
import BackArrow from "../../Components/Common/BackArrow";
import NewComment from "../../Components/Common/NewComment";
import LoadingLeft from "../../Components/Common/LoadingLeft";
import ActionModal from "../../Components/Common/Actionmodal";
import ButtonKonesh from "../../Components/Common/ButtonKonesh";
import ModalCart from "../../Components/Alerts/ModalCart";
import Toast from "../../Utils/Toast";

import "../../Styles/Book.css";
import { useRef } from "react";

const Book = (props) => {
  const params = useParams();
  const navigator = useNavigate();
  const location = useLocation();

  // console.log(params);
  // =========================================

  const [book, setBook] = useState({});
  const [bookRate, setBookRate] = useState(0);
  const [lastComment, setLastComment] = useState();

  const [score, setScore] = useState([0, 0, 0, 0, 0]);
  const [coin, setCoin] = useState([0, 0, 0, 0, 0]);
  const [actionModalIsOpen, setActionModalIsOpen] = useState(false);

  const [actions, setActions] = useState([]);

  const [showModalCart, setShowModalCart] = useState(false);
  const [showModalCartEror, setShowModalCartEror] = useState(false);

  const [konesh, setKonesh] = useState(false);
  // =========================================

  const readRef = useRef(null);
  const examRef = useRef(null);

  // =========================================

  const handleSelectAction = (action) => {
    if (book.isProfileComplete) {
      if (!book.isAction) {
        for (let item of actions) {
          if (item.title == action) {
            setActionModalIsOpen(item.id);
          }
        }
      } else {
        Toast("info", "قبلا برای این کتاب کنش ثبت کردی!");
        setKonesh(true);
      }
    } else {
      Toast("error", "اول اطلاعات پروفایلت رو تکمیل کن!");
      navigator("/edit-profile", {
        state: {
          prevPath: `/book/${window.location.pathname.split("/")[2]}/${
            book.preTitle
          }`,
        },
      });
    }
  };

  const handleBookRate = (rate) => {
    if (!book.isComment) {
      if (book.isProfileComplete) {
        Transaction_Book.AddBookRate({
          rate: rate,
          bookId: book.id,
        })
          .then((res) => {
            if (res[0]) {
              setBookRate(rate);
              getBook();
            } else {
              if (res[1] == "Please log in first") {
                Toast("error", " ابتدا ورود یا ثبت نام کنید ");
              } else {
                Toast("error", "مشکلی پیش آمد! دوباره تلاش کن.");
              }
            }
          })
          .catch((err) => Toast("error", "مشکلی پیش آمد! دوباره تلاش کن."));
      } else {
        Toast("error", "اول اطلاعات پروفایلت رو تکمیل کن!");
        navigator("/edit-profile", {
          state: {
            prevPath: `/book/${window.location.pathname.split("/")[2]}/${
              book.preTitle
            }`,
          },
        });
      }
    }
  };

  const [btnLoading, setBtnLoading] = useState(false);

  const [bookLayer, setBookLayer] = useState({
    bookCategory: "",
    bookTitle: "",
    bookId: 0,
    bookPrice: 0,
    bookNumber: 0,
  });

  const dataLayer = window.dataLayer;

  //buy electronic book
  const handleBuyBook = () => {
    var token = localStorage.getItem("Token");
    if (token != null && token != undefined) {
      const PostedData = { bookId: params.id };
      setBtnLoading(true);
      Transaction_Card.AddCart(PostedData)
        .then((res) => {
          if (res[0]) {
            navigator("/cart", {
              state: { BookID: params.id, bookName: params.name },
            });
            dataLayer.push({ ...bookLayer, bookType: "electronicBook" });
            setBtnLoading(false);
          } else {
            Toast("error", res[1]);
            setBtnLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setBtnLoading(false);
        });
    } else {
      Toast("error", "ابتدا وارد حساب خود شوید.");
    }
  };

  //buy physical book
  const handleBuyPhysicalBook = (url) => {
    dataLayer.push({ ...bookLayer, bookType: "physicalBook" });
    window.open(url, "_blank");
  };

  const getBook = () => {
    Transaction_Book.GetOneBooks(params.id)
      .then((res) => {
        if (res[0]) {
          setBookLayer({
            bookCategory: res[2].data.title,
            bookTitle: res[2].data.preTitle,
            bookId: res[2].data.id,
            bookPrice: res[2].data.price,
          });
          setBook(res[2].data);
          const mainEntity = {
            "@type": "Book",
            // author: "/author/jd_salinger.html",
            bookFormat: "https://schema.org/Paperback",
            // datePublished: "1991-05-01",
            image: res[2].data.pic,
            inLanguage: "Persian",
            // isbn: "0316769487",
            name: res[2].data.preTitle,
            // numberOfPages: "224",
            offers: {
              "@type": "Offer",
              availability: "https://schema.org/InStock",
              price: res[2].data.price,
              priceCurrency: "تومان",
            },
            // publisher: "Little, Brown, and Company",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: res[2].data.bookRate,
              // reviewCount: "3077",
            },
          };

          const schemaContent = {
            "@context": "https://schema.org",
            "@type": "WebPage",
            breadcrumb: "Books > Literature & Fiction > Classics",
            mainEntity: mainEntity,
          };

          const script = document.createElement("script");
          script.type = "application/ld+json";
          script.innerHTML = `${JSON.stringify(schemaContent)}`;
          document.head.appendChild(script);

          setBookRate(res[2].data.bookRate);

          setScore([
            res[2].data.isBuy || res[2].data.isPhysicalBuy
              ? res[2].data.scoreForBuy
              : 0,
            res[2].data.isRead || res[2].data.isPhysicalBuy
              ? res[2].data.scoreForRead
              : 0,
            res[2].data.isExamPass ? res[2].data.scoreForExam : 0,
            res[2].data.isAction ? res[2].data.scoreForAction : 0,
            res[2].data.isComment ? res[2].data.scoreForComment : 0,
          ]);

          setCoin([
            res[2].data.isBuy || res[2].data.isPhysicalBuy
              ? res[2].data.coinForBuy
              : 0,
            res[2].data.isRead || res[2].data.isPhysicalBuy
              ? res[2].data.coinForRead
              : 0,
            0,
            res[2].data.isAction ? res[2].data.coinForAction : 0,
            res[2].data.isComment ? res[2].data.coinForComment : 0,
          ]);
        } else {
          Toast("error", "کتاب پیدا نشد!");
          navigator("/hisstori/home");
        }
      })
      .catch((err) => console.log(err));
  };

  const getLastPost = () => {
    Transaction_Book.GetLastPost(params.id)
      .then((res) => {
        if (res[0]) setLastComment(res[2].data);
      })
      .catch((err) => console.log(err));
  };

  const handleExamClick = () => {
    if (book.isExam) {
      if (book.isProfileComplete) {
        navigator(`/exam/${book.id}`, {
          state: { bookName: params.name },
        });
      } else {
        Toast("error", "اول اطلاعات پروفایلت رو تکمیل کن!");
        navigator("/edit-profile", {
          state: {
            prevPath: `/book/${window.location.pathname.split("/")[2]}/${
              book.preTitle
            }`,
          },
        });
      }
    }
    if (book.isExamPass) {
      Toast("success", "قبلا در آزمون شرکت کردی!");
    }
  };

  const copyToClipBoard = async (text) => {
    await navigator.clipboard.writeText(text);
    Toast("success", "لینک با موفقیت برای اشتراک گذاری کپی شد!");
  };
  const getURL = () => {
    console.log(window.location.href);
  };

  // =========================================

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const Authority = urlParams.get("Authority");
    const Status = urlParams.get("Status");
    if (Authority != null && Status != "Ok") {
      Transaction_Payment.VerifyPayment(Authority).then((res) => {
        getBook();
        if (res[0]) {
          Toast("success", "خرید با موفقیت انجام شد");
        } else {
          Toast("error", "خرید شما ناموفق بوده است");
        }
      });
    } else if (Authority != null && Status == "Ok") {
      setShowModalCartEror(true);
    }

    getBook();

    getLastPost();

    Transaction_Action.GetActions().then((res) => {
      if (res[0]) setActions(res[2].data);
      console.log(res[2].data + "");
    });
  }, []);

  useEffect(() => {
    if (location?.state?.reGetBook) {
      getBook();
    }
    if (location?.state?.prevPath) {
      if (location?.state?.prevPath == "bookRead") {
        readRef.current.scrollIntoView();
      } else if (location?.state?.prevPath == "bookExam") {
        examRef.current.scrollIntoView();
      }
    }
  }, []);

  // =========================================

  useEffect(() => {
    if (book.preTitle !== undefined) {
      document.title = `خرید کتاب ${book.preTitle}`;
    }
  }, [book.preTitle]);

  return (
    <Page>
      <div
        className="Bookpage"
        id="top"
        style={{
          backgroundImage: "url('/imgs/Book/Book-page-star-bg.svg')",
        }}
      >
        {actionModalIsOpen ? (
          <ActionModal
            close={() => setActionModalIsOpen(false)}
            bookId={book.id}
            campaignActionId={actionModalIsOpen}
            getBook={getBook}
          />
        ) : null}

        <LoadingLeft percent={book.progressPercentage} />

        <Link to={"/hisstori/home"} className="Bookpage_BackIcon">
          <svg
            width="8"
            height="15"
            viewBox="0 0 8 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.16984 15C1.31923 15.0005 1.46684 14.9675 1.60182 14.9035C1.7368 14.8395 1.85572 14.746 1.94984 14.63L6.77984 8.63C6.92692 8.45107 7.00732 8.22663 7.00732 7.995C7.00732 7.76338 6.92692 7.53893 6.77984 7.36L1.77984 1.36C1.6101 1.15578 1.36619 1.02736 1.10176 1.00298C0.837334 0.978601 0.574053 1.06026 0.369836 1.23C0.16562 1.39974 0.0371957 1.64365 0.012816 1.90808C-0.0115638 2.1725 0.0700977 2.43578 0.239836 2.64L4.70984 8L0.389837 13.36C0.267554 13.5068 0.189877 13.6855 0.165997 13.8751C0.142118 14.0646 0.173034 14.257 0.25509 14.4296C0.337146 14.6021 0.466906 14.7475 0.629016 14.8486C0.791127 14.9497 0.978803 15.0022 1.16984 15Z"
              fill="white"
            ></path>
          </svg>
        </Link>
        {/* {showModalCart ? (
          <ModalCart
            image={"/imgs/cart/Asset.svg"}
            title={"خریدت با موفقیت انجام شد."}
            btnText={"برگشت به کتابنو"}
            close={() => setShowModalCart(false)}
          >
            <div className="ModalCart">
              <input
                className="ModalCart-input"
                id="Code"
                autoComplete={false}
                required
                type="text"
                disabled
              />
              <label htmlFor="Code" className="ModalCart-label">
                کد رهگیری
              </label>
              <button className="ModalCart-button">تایید کد</button>
            </div>
          </ModalCart>
        ) : null} */}

        {showModalCartEror ? (
          <ModalCart
            close={() => setShowModalCartEror(false)}
            image={"/imgs/cart/AssetError.svg"}
            title={"خریدت ناموفق بود!"}
            btnText={"برگشت به کتابنو"}
          />
        ) : null}
        <div className="Bookpage-item1">
          <div className="Bookpage-item1-display">
            <div className="Bookpage-item1-part1-right">
              <img
                className="Bookpage-item1-part1-right-image"
                src="/imgs/Book/Bookpage-item1-right.png"
              />
            </div>
            <div className="Bookpage-item1-part2-right">
              <div className="Bookpage-item1-part1-right-border">
                <p className="Bookpage-item1-part1-right-border-text">
                  {book.helps}
                </p>
              </div>
            </div>
          </div>

          <div className="Bookpage-responsive">
            <img
              className="Bookpage-responsive-line"
              src="/imgs/Book/Line5.svg"
            />
          </div>

          <div className="Bookpage-item1-part3-right">
            <img
              className="Bookpage-item1-part3-right-svg-top"
              src="/imgs/Book/Line1.svg"
            />
            <img
              className="Bookpage-item1-part3-right-svg-bottom"
              src="/imgs/Book/Line2.svg"
            />
          </div>

          <div className="Bookpage-item1-display2">
            <div className="Bookpage-item1-part4-center">
              <div className="Bookpage-item1-part4-center-image-div">
                <img
                  className="Bookpage-item1-part4-center-image"
                  src="/imgs/Book/Bookpage-item1-center-svg.svg"
                />
                <img
                  className="Bookpage-item1-part4-image-book"
                  src={book.pic}
                />
                <img
                  className="Bookpage-item1-part4-center-jeld-image"
                  src="/imgs/Book/Jeld.svg"
                />
              </div>
            </div>

            <div className="Bookpage-item1-part5-center">
              <div className="Bookpage-item1-part5-center-top">
                <p className="Bookpage-item1-part5-center-top-text1">
                  {book.title}
                </p>
                <p className="Bookpage-item1-part5-center-top-text2">
                  {book.preTitle}
                </p>
              </div>
              {/* price book desktop  */}
              <div className="parent-book-price d-mob-none">
                <div>
                  <div className="Bookpage-item1-part5-center-top2">
                    {book.isBuy ? null : (
                      <p className="Bookpage-item1-part5-center-top-text3 number-font">
                        {book.price} تومان
                      </p>
                    )}
                  </div>
                  <div
                    className="Bookpage-item1-part5-center-center add-cart-btn"
                    ref={readRef}
                    onClick={() =>
                      !book.isBuy && !btnLoading && handleBuyBook()
                    }
                    id={"addToCart"}
                  >
                    <Button
                      id={"buyBook"}
                      customClass={"buy-book-btn"}
                      text={"خرید کتاب الکترونیکی"}
                      mobilePosition={"right"}
                      disabled={book.isBuy ? true : btnLoading}
                    />
                  </div>
                </div>
                <div>
                  <div className="Bookpage-item1-part5-center-top2">
                    {book.isBuy ? null : (
                      <p className="Bookpage-item1-part5-center-top-text3 number-font">
                        {book.physicalPrice} تومان
                      </p>
                    )}
                  </div>
                  <div
                    className="Bookpage-item1-part5-center-center2"
                    onClick={() =>
                      !btnLoading && handleBuyPhysicalBook(book?.physycalUrl)
                    }
                  >
                    <Button
                      text={"خرید کتاب چاپی"}
                      mobilePosition={"right"}
                      disabled={btnLoading}
                    />
                  </div>
                </div>
              </div>
              <div className="Bookpage-item1-part5-center-bottom">
                <img
                  className="Bookpage-item1-part5-center-bottom-image"
                  src="/imgs/Book/Abr.svg"
                />
              </div>
            </div>
          </div>
          {/* price book mobile  */}
          <div className="parent-book-price d-desktop-none">
            <div>
              <div className="Bookpage-item1-part5-center-top2">
                {book.isBuy ? null : (
                  <p className="Bookpage-item1-part5-center-top-text3 number-font">
                    {book.physicalPrice} تومان
                  </p>
                )}
              </div>
              <div
                onClick={() =>
                  !btnLoading && handleBuyPhysicalBook(book?.physycalUrl)
                }
                className="Bookpage-item1-part5-center-center2"
              >
                <Button
                  text={"خرید کتاب چاپی"}
                  mobilePosition={"right"}
                  disabled={btnLoading}
                />
              </div>
            </div>
            <div>
              <div className="Bookpage-item1-part5-center-top2">
                {book.isBuy ? null : (
                  <p className="Bookpage-item1-part5-center-top-text3 number-font">
                    {book.price} تومان
                  </p>
                )}
              </div>
              <div
                className="Bookpage-item1-part5-center-center add-cart-btn"
                ref={readRef}
                onClick={() => !book.isBuy && !btnLoading && handleBuyBook()}
                id={"addToCart"}
              >
                <Button
                  id={"buyBook"}
                  customClass={"buy-book-btn"}
                  text={"خرید کتاب الکترونیکی"}
                  mobilePosition={"right"}
                  disabled={book.isBuy ? true : btnLoading}
                />
              </div>
            </div>
          </div>

          <div className="Bookpage-responsive">
            <img
              className="Bookpage-responsive-line"
              src="/imgs/Book/Line5.svg"
            />
          </div>
          {book.isBuy || book.isPhysicalBuy ? (
            <div className="Bookpage-item1-part6-left">
              <div className="Bookpage-item1-part6-left-top">
                <Box
                  Boximg="/imgs/Book/Group.svg"
                  Boxtext={`تبریک برای خرید کتاب ${book.scoreForBuy} امتیاز گرفتی!`}
                  Boxnumber={"امتیازهات"}
                  coundOfWard={
                    book.isBuy || book.isPhysicalBuy ? book.scoreForBuy : 0
                  }
                />
              </div>
              <div className="Bookpage-item1-part6-left-bottom">
                <Box
                  Boximg="/imgs/Book/Seke.svg"
                  Boxtext={`تبریک برای خرید کتاب ${book.coinForBuy} سکه گرفتی!`}
                  Boxnumber={"سکه هات"}
                  coundOfWard={
                    book.isBuy || book.isPhysicalBuy ? book.coinForBuy : 0
                  }
                />
              </div>
            </div>
          ) : (
            <div className="Bookpage-item1-part6-left">
              <div className="Bookpage-item1-part6-left-top">
                <Box
                  Boximg="/imgs/Book/Group.svg"
                  Boxtext={`کتاب رو بخر و ${book.scoreForBuy} امتیاز بگیر`}
                  Boxnumber={"امتیازهات"}
                  coundOfWard={book.isBuy ? book.scoreForBuy : 0}
                  disabled={true}
                />
              </div>
              <div className="Bookpage-item1-part6-left-bottom">
                <Box
                  Boximg="/imgs/Book/Seke.svg"
                  Boxtext={`کتاب رو بخر و ${book.coinForBuy} سکه بگیر`}
                  Boxnumber={"سکه هات"}
                  coundOfWard={book.isBuy ? book.coinForBuy : 0}
                  disabled={true}
                />
              </div>
            </div>
          )}
        </div>

        <div className="Bookpage-responsive">
          <img
            className="Bookpage-responsive-line"
            src="/imgs/Book/Line5.svg"
          />
        </div>

        <div className="Bookpage-item2">
          <div className="Bookpage-item2-part1-right">
            <div className="Bookpage-item2-part1-right-top">
              <div className="Bookpage-display5">
                <div>
                  <div className="Bookpage-item2-part1-right-top-fortext">
                    <p className="Bookpage-item2-part1-right-top-text1">
                      اینجا باید کتاب رو بخونی
                      <br />
                      تا امتیازش رو بگیری
                    </p>
                  </div>
                  <div
                    className="Bookpage-item2-part1-right-center"
                    onClick={() => {
                      !book.isBuy &&
                        Toast("error", "ابتدا کتاب را خریداری نمایید");
                    }}
                  >
                    {book.lastPageView > 0 && book.isBuy ? (
                      <Button
                        text={"خوندن"}
                        mobilePosition={"right"}
                        disabled={!book.isBuy}
                        link={`/book/${book.id}/read`}
                      />
                    ) : (
                      <Button
                        text={"خوندن"}
                        mobilePosition={"right"}
                        disabled={!book.isBuy}
                        link={`/book/${book.id}/read`}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="Bookpage-item2-part1-right-left">
                <img
                  className="Bookpage-item2part2-right-image"
                  src="/imgs/Book/Bookpage-item2-right.png"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="Bookpage-responsive">
          <img
            className="Bookpage-responsive-line"
            src="/imgs/Book/Line5.svg"
          />
        </div>

        <div className="Bookpage-item3">
          <div className="Bookpage-item3-inside">
            <div className="Bookpage-item3-part1">
              {book.isRead || book.isPhysicalBuy ? (
                <div className="Bookpage-item1-part6-left">
                  <div className="Bookpage-item1-part6-left-top">
                    <Box
                      Boximg="/imgs/Book/Group.svg"
                      Boxtext={`تبریک برای خوانش کتاب ${book.scoreForRead} امتیاز گرفتی!`}
                      Boxnumber={"امتیازهات"}
                      coundOfWard={score.slice(0, 2).reduce((a, b) => a + b)}
                    />
                  </div>
                  <div className="Bookpage-item1-part6-left-bottom">
                    <Box
                      Boximg="/imgs/Book/Seke.svg"
                      Boxtext={`تبریک برای خوانش کتاب ${book.coinForRead} سکه گرفتی!`}
                      Boxnumber={"سکه هات"}
                      coundOfWard={coin.slice(0, 2).reduce((a, b) => a + b)}
                    />
                  </div>
                </div>
              ) : (
                <div className="Bookpage-item1-part6-left">
                  <div className="Bookpage-item1-part6-left-top">
                    <Box
                      Boximg="/imgs/Book/Group.svg"
                      Boxtext={`کتاب رو بخوان و ${book.scoreForRead} امتیاز بگیر`}
                      Boxnumber={"امتیازهات"}
                      coundOfWard={book.isBuy ? book.scoreForBuy : 0}
                      disabled={true}
                    />
                  </div>
                  <div className="Bookpage-item1-part6-left-bottom">
                    <Box
                      Boximg="/imgs/Book/Seke.svg"
                      Boxtext={`کتاب رو بخوان و ${book.coinForRead} سکه بگیر`}
                      Boxnumber={"سکه هات"}
                      coundOfWard={book.isBuy ? book.coinForBuy : 0}
                      disabled={true}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="Bookpage-responsive">
              <img
                className="Bookpage-responsive-line"
                src="/imgs/Book/Line5.svg"
              />
            </div>

            <div className="Bookpage-item3-part2">
              <img
                className="Bookpage-item3-part1-right-inside-right-line"
                src="/imgs/Book/Line3.svg"
              />
            </div>

            <div className="Bookpage-item1-display3">
              <div className="Bookpage-item3-part3">
                <div className="Bookpage-display9">
                  <div className="Bookpage-item3-part3-center-top">
                    <p
                      ref={examRef}
                      className="Bookpage-item3-part3-center-top-text1"
                    >
                      اینجا می تونی آزمون بدی و امتیاز بگیری...
                    </p>
                    <p className="Bookpage-item3-part3-center-top-text2">
                      اجازه شروع آزمون :&nbsp;
                      <span className="number-font">
                        {book.allowAttemtExam}
                      </span>
                    </p>
                  </div>
                  <div
                    className="Bookpage-item3-part3-center-bottom"
                    onClick={() => handleExamClick()}
                  >
                    <Button
                      text={"آزمون"}
                      mobilePosition={"right"}
                      disabled={book.isExamPass || !book.isExam}
                      //   link={
                      //     book.isProfileComplete ? `/exam/${book.id}` : "/profile"
                      //   }
                      //   toastText={
                      //     book.isProfileComplete
                      //       ? []
                      //       : ["warning", "لطفا پروفایل خود را کامل کنید."]
                      //   }
                    />
                  </div>
                </div>
                <div className="Bookpage-item3-part4-inside-line">
                  <img
                    className="Bookpage-item3-part4-line"
                    src="/imgs/Book/Line4.svg"
                  />
                </div>
              </div>

              <div className="Bookpage-item3-part4">
                <img
                  className="Bookpage-item3-part4-image"
                  src="/imgs/Book/Bookpage-item2-center.png"
                />
              </div>
            </div>
            <div className="Bookpage-responsive">
              <img
                className="Bookpage-responsive-line"
                src="/imgs/Book/Line5.svg"
              />
            </div>
            <div className="Bookpage-item3-part5">
              {book.isExamPass ? (
                <Box
                  Boximg="/imgs/Book/Group.svg"
                  Boxtext={`تبریک برای قبولی آزمون ${book.scoreForExam} امتیاز گرفتی!`}
                  Boxnumber={"امتیازهات"}
                  coundOfWard={score.slice(0, 3).reduce((a, b) => a + b)}
                />
              ) : (
                <Box
                  Boximg="/imgs/Book/Group.svg"
                  Boxtext={`اگر تو آزمون قبول بشی ${book.scoreForExam} امتیاز میگیری`}
                  Boxnumber={"امتیازهات"}
                  coundOfWard={score.slice(0, 3).reduce((a, b) => a + b)}
                  disabled={true}
                />
              )}
            </div>
          </div>
        </div>

        <div className="Bookpage-responsive">
          <img
            className="Bookpage-responsive-line"
            src="/imgs/Book/Line5.svg"
          />
        </div>

        <div className="Bookpage-item4">
          <div className="Bookpage-item4-inside">
            <div className="Bookpage-item1-display4">
              <div className="Bookpage-item4-part1-right">
                <div className="Bookpage-item4-part1-right-top">
                  <p className="Bookpage-item4-part1-right-top-text-1">
                    حالا وقتـشه که هــنرت رو نشون بدی! یکی از قالب‌ها رو انتخاب
                    کن و سکه و امتیاز این بخش رو بگیر :)
                  </p>
                </div>
                <div className="Bookpage-item4-part1-right-botttom">
                  <div className="Bookpage-item4-part1-right-botttom-img">
                    <div className="Bookpage-item4-part1-right-botttom-img-top">
                      <div
                        className="Bookpage-item4-part1-right-botttom-item Bookpage-item4-part1-right-botttom-item-first"
                        onClick={() => getURL()}
                      >
                        <img src="/imgs/Book/Naghashi.png" />
                        <div
                          className="Bookpage-item4-part1-item-ButtonKonesh"
                          onClick={() => handleSelectAction("نقاشی و کمیک")}
                        >
                          <ButtonKonesh
                            text={"نقاشی/ کمیک"}
                            disable={book.isAction}
                          />
                        </div>
                      </div>
                      <div
                        className="Bookpage-item4-part1-right-botttom-item"
                        onClick={() => getURL()}
                      >
                        <img src="/imgs/Book/Neveshteh.png" />
                        <div
                          className="Bookpage-item4-part1-item-ButtonKonesh"
                          onClick={() =>
                            handleSelectAction("پوستر / عکس نوشته")
                          }
                        >
                          <ButtonKonesh
                            text={"پوستر / عکس نوشته"}
                            disable={book.isAction}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="Bookpage-item4-part1-right-botttom-img-bottom"
                      onClick={() => getURL()}
                    >
                      <div
                        style={{ marginTop: "10px" }}
                        className="Bookpage-item4-part1-right-botttom-item"
                      >
                        <img src="/imgs/Book/poster.png" />
                        <div
                          className="Bookpage-item4-part1-item-ButtonKonesh"
                          onClick={() => handleSelectAction("چت استوری")}
                        >
                          <ButtonKonesh
                            text={"چت استوری"}
                            disable={book.isAction}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          marginTop: "-15px",
                        }}
                      >
                        {/* <div> */}
                        <div
                          className="Bookpage-item4-part1-right-botttom-item "
                          onClick={() => getURL()}
                          style={{ marginRight: "20px" }}
                        >
                          <img src="/imgs/Book/pad.png" />
                          <div
                            className="Bookpage-item4-part1-item-ButtonKonesh"
                            onClick={() => handleSelectAction("پادکست")}
                          >
                            <ButtonKonesh
                              text={"پادکست"}
                              disable={book.isAction}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <img
                    style={{ marginTop: "40px" }}
                    className="Bookpage-item4-part1-right-botttom-image"
                    src="/imgs/Book/konesh-img.png"
                  />
                  {/* <span
                                        className="poster-action"
                                        onClick={() =>
                                            handleSelectAction("پوستر")
                                        }
                                    >
                                        پوستر
                                    </span>
                                    <span
                                        className="drawComic-action"
                                        onClick={() =>
                                            handleSelectAction("نقاشی و کمیک")
                                        }
                                    >
                                        نقاشی/کمیک
                                    </span>
                                    <span
                                        className="image-action"
                                        onClick={() =>
                                            handleSelectAction("عکس نوشته")
                                        }
                                    >
                                        عکس‌نوشت
                                    </span>
                                    <span
                                        className="podcast-action"
                                        onClick={() =>
                                            handleSelectAction("پادکست")
                                        }
                                    >
                                        پادکست
                                    </span> */}
                </div>
              </div>

              <div
                className="Bookpage-item4-part2-center"
                onClick={() =>
                  navigator(`/hisstori/blog/${book.id}/action`, {
                    state: {
                      actionId: 5,
                      bookName: params.name,
                    },
                  })
                }
              >
                <Button
                  text={"کنش بقیه کاربرها"}
                  mobilePosition={"right"}
                  prevPath={`/book/${book.id}`}
                />
              </div>
              <div className="Bookpage-responsive">
                <img
                  className="Bookpage-responsive-line"
                  src="/imgs/Book/Line5.svg"
                />
              </div>

              <div className="Bookpage-item4-part2-left">
                <div className="Bookpage-item4-part2-left-inside">
                  {book.isAction ? (
                    <>
                      <div className="Bookpage-item4-part2-left-top">
                        <Box
                          Boximg="/imgs/Book/Group.svg"
                          Boxtext={`تبریک به خاطر انجام کنش ${book.scoreForAction} امتیاز گرفتی!`}
                          Boxnumber={"امتیازهات"}
                          coundOfWard={score
                            .slice(0, 4)
                            .reduce((a, b) => a + b)}
                        />
                      </div>
                      <div className="Bookpage-item4-part2-left-center">
                        <Box
                          Boximg="/imgs/Book/Seke.svg"
                          Boxtext={`تبریک به خاطر انجام کنش ${book.coinForAction} سکه گرفتی!`}
                          Boxnumber={"سکه هات"}
                          coundOfWard={coin.slice(0, 4).reduce((a, b) => a + b)}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="Bookpage-item4-part2-left-top">
                        <Box
                          Boximg="/imgs/Book/Group.svg"
                          Boxtext={`اگر یه کنش بفرستی ${book.scoreForAction} امتیاز میگیری`}
                          Boxnumber={"امتیازهات"}
                          disabled={true}
                          coundOfWard={score
                            .slice(0, 4)
                            .reduce((a, b) => a + b)}
                        />
                      </div>
                      <div className="Bookpage-item4-part2-left-center">
                        <Box
                          Boximg="/imgs/Book/Seke.svg"
                          Boxtext={`اگر یه کنش بفرستی ${book.coinForAction} سکه میگیری`}
                          Boxnumber={"سکه هات"}
                          disabled={true}
                          coundOfWard={coin.slice(0, 4).reduce((a, b) => a + b)}
                        />
                      </div>
                    </>
                  )}
                  <div className="Bookpage-item4-part2-left-botton">
                    <img
                      className="Bookpage-item4-part2-left-botton-line"
                      src="/imgs/Book/Line5.svg"
                    />
                    <div className="Bookpage-responsive">
                      <img
                        className="Bookpage-responsive-line"
                        src="/imgs/Book/Line5.svg"
                      />
                    </div>
                    <div className="Bookpage-display7">
                      <div className="Bookpage-item4-part2-left-botton-border">
                        <p className="Bookpage-item4-part2-left-botton-border-text1">
                          چقدر از این کتاب خوشت اومد؟
                        </p>
                        <p className="Bookpage-item4-part2-left-botton-border-text2">
                          با ایموجی بهش امتیاز بده!
                        </p>
                      </div>
                      <div className="Bookpage-item4-part2-left-botton-image">
                        <img
                          className="Bookpage-item4-part2-left-botton-image-pen"
                          src="/imgs/Common/pen.svg"
                        />
                      </div>
                      <div className="Bookpage-item4-part2-left-botton-box">
                        <div
                          style={
                            book.isComment ? { pointerEvents: "none" } : {}
                          }
                          className="Bookpage-item4-part2-left-botton-box-emoji"
                        >
                          <img
                            className={`Bookpage-item4-part2-left-botton-box-emoji-img ${
                              bookRate == 1 ? "active" : ""
                            }`}
                            src="/imgs/Book/em1.png"
                            onClick={() => handleBookRate(1)}
                          />
                          <img
                            className={`Bookpage-item4-part2-left-botton-box-emoji-img ${
                              bookRate == 2 ? "active" : ""
                            }`}
                            src="/imgs/Book/em2.png"
                            onClick={() => handleBookRate(2)}
                          />
                          <img
                            className={`Bookpage-item4-part2-left-botton-box-emoji-img ${
                              bookRate == 3 ? "active" : ""
                            }`}
                            src="/imgs/Book/em3.png"
                            onClick={() => handleBookRate(3)}
                          />
                          <img
                            className={`Bookpage-item4-part2-left-botton-box-emoji-img ${
                              bookRate == 4 ? "active" : ""
                            }`}
                            src="/imgs/Book/em4.png"
                            onClick={() => handleBookRate(4)}
                          />
                          <img
                            className={`Bookpage-item4-part2-left-botton-box-emoji-img ${
                              bookRate == 5 ? "active" : ""
                            }`}
                            src="/imgs/Book/em5.png"
                            onClick={() => handleBookRate(5)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="Bookpage-responsive">
          <img
            className="Bookpage-responsive-line"
            src="/imgs/Book/Line5.svg"
          />
        </div>

        <div className="Bookpage-item5">
          <div className="Bookpage-item5-inside">
            <img
              className="Bookpage-item5-inside-image"
              src="/imgs/Book/Line6.svg"
            />
          </div>
        </div>

        <div className="Bookpage-item6">
          <div className="Bookpage-item6-inside">
            <div className="Bookpage-item6-inside-right">
              <NewComment
                book={book}
                comment={lastComment}
                getLastPost={getLastPost}
                getBook={getBook}
              />
              {/* <div className="Bookpage-item6-inside-right-comment mobile-hidden">
                <p className="Bookpage-item6-inside-right-text">
                  مشاهده بقیه نظرات
                </p>
              </div> */}
            </div>

            <div
              className="Bookpage-item6-inside-right desktop-hidden"
              onClick={() =>
                navigator(`/hisstori/blog/${book.id}/action`, {
                  state: { actionId: 0 },
                })
              }
            >
              {/* <div className="Bookpage-item6-inside-right-comment">
                <p className="Bookpage-item6-inside-right-text">
                  مشاهده بقیه نظرات
                </p>
              </div> */}
              <div className="seeMore-button-parent">
                <Button
                  text={"مشاهده بقیه نظرات"}
                  mobilePosition={"right"}
                  prevPath={`/book/${book.id}`}
                />
              </div>
            </div>

            <div className="Bookpage-responsive">
              <img
                className="Bookpage-responsive-line"
                src="/imgs/Book/Line5.svg"
              />
            </div>
            <div className="Bookpage-item6-inside-center">
              {book.isComment ? (
                <>
                  <div className="Bookpage-item6-inside-center-top">
                    <Box
                      Boximg="/imgs/Book/Group.svg"
                      Boxtext={`تبریک برای ارسال نظر ${book.scoreForComment} امتیاز گرفتی!`}
                      Boxnumber={"امتیازهات"}
                      coundOfWard={score.reduce((a, b) => a + b)}
                    />
                  </div>
                  <div className="Bookpage-item6-inside-center-bottom">
                    <Box
                      Boximg="/imgs/Book/Seke.svg"
                      Boxtext={`تبریک برای ارسال نظر ${book.coinForComment} سکه گرفتی!`}
                      Boxnumber={"سکه هات"}
                      coundOfWard={coin.reduce((a, b) => a + b)}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="Bookpage-item6-inside-center-top">
                    <Box
                      Boximg="/imgs/Book/Group.svg"
                      Boxtext={`اگر نظرتو بفرستی ${book.scoreForComment} امتیاز میگیری`}
                      Boxnumber={"امتیازهات"}
                      coundOfWard={score.reduce((a, b) => a + b)}
                      disabled={true}
                    />
                  </div>
                  <div className="Bookpage-item6-inside-center-bottom">
                    <Box
                      Boximg="/imgs/Book/Seke.svg"
                      Boxtext={`اگر نظرتو بفرستی ${book.coinForComment} سکه میگیری`}
                      Boxnumber={"سکه هات"}
                      coundOfWard={coin.reduce((a, b) => a + b)}
                      disabled={true}
                    />
                  </div>
                </>
              )}
            </div>
            <div
              className="Bookpage-item6-inside-left mobile-hidden"
              onClick={() =>
                navigator(`/hisstori/blog/${book.id}/action`, {
                  state: { actionId: 0 },
                })
              }
            >
              <Button
                text={"دیدن بقیه نظرها"}
                mobilePosition={"right"}
                prevPath={`/book/${book.id}`}
              />
            </div>
          </div>
        </div>

        <div className="Bookpage-responsive">
          <img
            className="Bookpage-responsive-line"
            src="/imgs/Book/Line5.svg"
          />
        </div>

        <div className="Bookpage-item7">
          <div className="Bookpage-item7-inside">
            <img
              className="Bookpage-item7-inside-line"
              src="/imgs/Book/Line7.svg"
            />
            <div className="Bookpage-item7-inside-box">
              <BoxPlural
                coins={book.allCoins || 0}
                scores={book.allScores || 0}
              />
            </div>
          </div>
        </div>

        <div className="Bookpage-item8">
          <div className="Bookpage-item8-inside">
            <div className="Bookpage-item8-inside-right">
              <div className="Bookpage-item8-inside-right-pre">
                <a href="#top" className="Bookpage_BackArrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="10"
                    viewBox="0 0 15 10"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.0979 5.05276C14.0979 4.91928 14.0449 4.79127 13.9505 4.69688C13.8561 4.6025 13.7281 4.54947 13.5946 4.54947H1.72403L4.89173 1.38278C4.98623 1.28827 5.03933 1.1601 5.03933 1.02645C5.03933 0.892798 4.98623 0.764622 4.89173 0.670118C4.79722 0.575614 4.66905 0.522522 4.5354 0.522522C4.40175 0.522522 4.27358 0.575614 4.17907 0.670118L0.152756 4.69643C0.105886 4.74319 0.0687008 4.79872 0.0433283 4.85987C0.0179558 4.92101 0.00489616 4.98656 0.00489616 5.05276C0.00489616 5.11896 0.0179558 5.18451 0.0433283 5.24566C0.0687008 5.3068 0.105886 5.36234 0.152756 5.40909L4.17907 9.43541C4.27358 9.52991 4.40175 9.583 4.5354 9.583C4.66905 9.583 4.79722 9.52991 4.89173 9.43541C4.98623 9.3409 5.03933 9.21273 5.03933 9.07908C5.03933 8.94543 4.98623 8.81726 4.89173 8.72275L1.72403 5.55605H13.5946C13.7281 5.55605 13.8561 5.50303 13.9505 5.40864C14.0449 5.31426 14.0979 5.18624 14.0979 5.05276Z"
                      fill="#fff"
                      stroke="#fff"
                    />
                  </svg>
                </a>
                <p className="Bookpage-item8-inside-right-pre-text">برو بالا</p>
              </div>
              <div className="Bookpage-item8-inside-right-nex">
                <p className="Bookpage-item8-inside-right-nex-text">
                  {" "}
                  برو کتاب بعدی
                </p>
                <div className="Bookpage-item8-inside-right-nex-border-buttom">
                  <BackArrow
                    link={"/hisstori/home"}
                    left="none"
                    top={"-10px"}
                  />
                </div>
              </div>
            </div>

            <div className="Bookpage-item8-inside-left">
              <img
                className="Bookpage-item8-inside-left-image"
                src="/imgs/Book/Bookpage-item8-left.png"
              />
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default Book;
